import React, { HTMLAttributes, FC } from 'react';
import { cx } from 'linaria';
import { paddingX, paddingY, hoverLayout, focusLayout } from './styles';

interface MenuContentLayerProps extends HTMLAttributes<HTMLElement> {
  vertical?: boolean;
  horizontal?: boolean;
  withHover?: boolean;
  focused?: boolean;
}

export const MenuContentLayer: FC<MenuContentLayerProps> = (props) => {
  const {
    vertical = false,
    horizontal = false,
    withHover = false,
    focused = false,
    children,
    className,
    ...rest
  } = props;

  const classNames = cx(
    className,
    horizontal && paddingX,
    vertical && paddingY,
    withHover && hoverLayout,
    focused && focusLayout,
  );

  return (
    <div className={classNames} {...rest}>
      {children}
    </div>
  );
};
